import 'babel-polyfill'
import 'app.css'

import React from 'react'
import ReactDOM from 'react-dom'

import { Provider } from 'mobx-react'
import { Router, browserHistory } from 'react-router'

import routes from './routes'
import Auth from './stores/auth'
import AuthLoading from './components/auth/AuthLoading'
import { loadStripe } from './stripe'

const auth = new Auth()

ReactDOM.render(
  <Provider auth={auth}>
    <AuthLoading auth={auth}>
      <Router history={browserHistory} children={routes(auth)} />
    </AuthLoading>
  </Provider>,
  document.getElementById('root')
)

loadStripe()



// WEBPACK FOOTER //
// client/index.js